// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input.PhoneInputInput {\n  border: none;\n}", "",{"version":3,"sources":["webpack://src/Components/UserManagement/UserManagement.scss"],"names":[],"mappings":"AAAA;EAAuB,YAAA;AAEvB","sourcesContent":["input.PhoneInputInput{ border:none; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
